import { createActionGroup } from '@ngrx/store';

export const ComposantGroupeActions = createActionGroup({
  source: 'Composant Groupe',
  events: {}
});
